import React, { useEffect, useState } from "react";
import { IUIPropertyDefinitionMap, IWDDesignModeProps, IWidgetTemplateProps, findAvailableFields, registerCardTemplate, registerMobileCardTemplate } from "../../../common/common";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import './CardList.scss'
import { TextProperty, extractTextProperties } from "../../../common/ui-props/TextProperty";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import { extractContextData, hasValue, loadInitialData, replaceWithData } from "../../../../util";
import { WidgetWrapper, useEffectWithPolling } from "uxp/components";

import { Pagination, EffectCoverflow, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { DataSourceContext, executeAndBind } from "../../../common/data-source-picker/datasource";
import { ACTextProperty } from "../../../common/ui-props/ACTextProperty";
import { SimpleNumberProperty } from "../../../common/ui-props/SimpleNumberProperty";
import { CardListProperty, ICardListProps } from "./CardListProperty";
import classNames from "classnames";
import { PillInputProperty } from "../../../common/ui-props/PillInputProperty";

const defaultXPRProps = {
  title: {
    text: "Experience Adventure With Madinah",
    color: "rgba(0, 0, 0, 1)",
    size: "13px"
  },
  subtitle: {
    text: "Top Attractions Related To Madinah History",
    color: "",
    size: "10px",
  },
  actionLabel: {
    text: "See More",
    color: "",
    size: "12px"
  },

  itemTitle: {
    text: "Experience Madinah's Culture",
    color: "rgba(255, 255, 255, 1)",
    size: "13px"
  },
  itemSubtitle: {
    text: "Get A Tour Guide To See Madinah With In 5 Minutes By Vehicle",
    color: "rgba(255, 255, 255, 1)",
    size: "10px",
  },
  itemImageField: '{$.row.backgroundImage}',
  itemSubtitleField: '{$.row.subtitle}',
  itemTitleField: '{$.row.title}',
  cardListConfig: {
    viewHeight: 330,
    slidesPerView: 1.2,
    centeredSlides: true,
    makeInactiveSlidesSmall: true,
    showImageSeperately: false
  } as ICardListProps
}


let defaultItemsData = [
  {
    title: "4x4 Sight Seeing Tour in Al Ula",
    subtitle: "Start your day with a thrilling 4x4 dune bashing experience in the desert.",
    backgroundImage: "https://picsum.photos/id/83/600/600"
  },
  {
    title: "3 Hour Al Ula Hiking Adventure",
    subtitle: "Head to the Dhihin Desert Oasis and take a refreshing dip in the clear waters.",
    backgroundImage: "https://picsum.photos/id/84/600/600"
  },
  {
    title: "Hourse Riding Through Farm In Madinah",
    subtitle: "Horseback ride through Madinah's picturesque farmlands—a serene and rustic journey.",
    backgroundImage: "https://picsum.photos/id/62/600/600"
  }
]

const CardListWidget: React.FunctionComponent<IWidgetTemplateProps> = (props) => {
  let uiProps = Object.keys(props?.uiProps).length ? props?.uiProps : defaultXPRProps;

  findAvailableFields(uiProps.source, uiProps.datasources, {});
  let pv = Object.keys({});
  pv.sort();

  const XPRProps: IUIPropertyDefinitionMap = {
    'container': ContainerProperty({
      background: {
        image: {
          image: '',
          position: 'center',
          size: 'cover'
        }
      },
      onClick: { type: 'open-url' }
    }),
    'topLabelContainer': ContainerProperty({
      background: {
        color: '',
        image: {
          image: "",
          position: "",
          size: "",
        },
      }
    }),
    'topLabel': TextProperty({
      text: '',
      color: '',
      size: '12px'
    }),
    'titlesContainer': ContainerProperty({
      background: { color: "" }
    }),

    'title': TextProperty(defaultXPRProps.title, "Title"),
    'subtitle': TextProperty(defaultXPRProps.subtitle, "Subtitle"),

    'itemTitle': TextProperty(defaultXPRProps.itemTitle, "Item Title"),
    'itemSubtitle': TextProperty(defaultXPRProps.itemSubtitle, "Item Sub Title"),

    'itemTitleField': PillInputProperty('Item Title Field', uiProps.itemTitleField || defaultXPRProps.itemTitleField),
    'itemSubtitleField': PillInputProperty('Item Sub Title Field', uiProps.itemSubtitleField || defaultXPRProps.itemSubtitleField),
    'itemImageField': PillInputProperty('Item Image Field', uiProps.itemImageField || defaultXPRProps.itemImageField),

    'cardListConfig': CardListProperty('Card List Config', uiProps.cardListConfig || defaultXPRProps.cardListConfig),

    'source': DataSourceProperty('Data Source For Cards', uiProps?.source, uiProps?.datasources, props.uxpContext, props.designer, 'dictionary-array'),
    'refreshInterval': SimpleTextProperty('Refresh Time', '3000'),
  }

  const [actionData, setActionData] = React.useState({ action: null, data: {} })
  const [loading, setLoading] = React.useState(false)
  let [contextData, setContextData] = React.useState<any>({})

  const [widgetData, setWidgetData] = React.useState<any>({
    'defaultSource': defaultItemsData
  })

  React.useEffect(() => {
    loadInitialDataAndContextData()
  }, [props])

  async function loadInitialDataAndContextData() {
    const { isLoading, initialData } = await loadInitialData(props)
    setLoading(isLoading)

    const _data = await extractContextData(props, initialData, contextData)
    setContextData(_data)
  }

  // main container 
  let { styles, onClick } = extractContainerProperties(uiProps.container)
  if (!styles.backgroundImage) styles.backgroundImage = 'url("https://picsum.photos/id/113/600/600")'

  // titles
  let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title || defaultXPRProps.title, defaultXPRProps.title.text)
  let { text: subtitle, styles: subtitleStyles } = extractTextProperties(uiProps.subtitle || defaultXPRProps.subtitle, defaultXPRProps.subtitle.text)
  let { text: actionLabel, styles: actionLabelStyles } = extractTextProperties(uiProps.actionLabel || defaultXPRProps.actionLabel, defaultXPRProps.actionLabel.text)

  let refreshInterval = Number(uiProps?.refreshInterval) || 2000;

  let itemTitleField = uiProps?.itemTitleField || defaultXPRProps.itemTitleField;
  let itemSubtitleField = uiProps?.itemSubtitleField || defaultXPRProps.itemSubtitleField;
  let itemImageField = uiProps?.itemImageField || defaultXPRProps.itemImageField;

  const isInDesignerMode = () => props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')
  const isInThumbnailMode = () => props.designer && (props.designer.mode == 'thumbnail')

  let {
    viewHeight,
    slidesPerView,
    centeredSlides,
    makeInactiveSlidesSmall,
    showImageSeperately
  }
    = uiProps.uiProps?.cardListConfig || defaultXPRProps.cardListConfig


  function getParsedValue(data: any, value: string, defaultFieldName: string) {
    if (isInDesignerMode()) {
      return replaceWithData(defaultFieldName, data) || ''
    }

    if (!hasValue(value)) return ''
    return replaceWithData(value, data) || ''
  }


  function renderCard(data: any, key: number) {
    let { text: itemDefaultTitle, styles: itemTitleStyles } = extractTextProperties(uiProps.itemTitle || defaultXPRProps.itemTitle, 'Explore the world')
    let { text: itemDefaultSubtitle, styles: itemSubtitleStyles } = extractTextProperties(uiProps.itemSubtitle || defaultXPRProps.itemTitle, 'Lucy brings the power to the world')

    let cardHeight = viewHeight - 50

    let swiperSlideStyles = {
      height: cardHeight + "px"
    } as React.CSSProperties

    let d = { row: data, ...widgetData }
    let titleValue = getParsedValue(d, itemTitleField, defaultXPRProps.itemTitleField)
    let subtitleValue = getParsedValue(d, itemSubtitleField, defaultXPRProps.itemSubtitleField)
    let backgroundImageValue = getParsedValue(d, itemImageField, defaultXPRProps.itemImageField)

    swiperSlideStyles.backgroundImage = `url("${backgroundImageValue}")`
    swiperSlideStyles.backgroundSize = 'cover';

    if (showImageSeperately) {
      swiperSlideStyles.background = `transparent`
    }

    return (
      <SwiperSlide
        className={classNames("wd-card-list-card", { "scale-down-inactive-slides": makeInactiveSlidesSmall })}
        key={key}
        style={swiperSlideStyles}
      >
        <SelectableItem
          designer={props.designer}
          props={selectUIProps(uiProps, XPRProps, 'cardListConfig', 'itemImageField', 'source', 'refreshInterval')}
          elementId={props.instanceId}
          key={key}
        >
          <div className="wd-slider-card-content-container">
            {showImageSeperately && (
              <div className="item-inner-image">
                <SelectableItem
                  designer={props.designer}
                  props={selectUIProps(uiProps, XPRProps, 'itemImageField')}
                  elementId={props.instanceId}
                  key={key}
                >
                  <div className="image" style={{ backgroundSize: 'cover', backgroundImage: `url("${backgroundImageValue}")` }}></div>
                </SelectableItem>
              </div>
            )}

            <div className="item-title">
              <SelectableItem
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'itemTitle', 'itemTitleField')}
                elementId={props.instanceId}
                key={key}
              >
                <div className="text" style={itemTitleStyles}>
                  {titleValue}
                </div>
              </SelectableItem>
            </div>

            <div className="item-sub-title">
              <SelectableItem
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'itemSubtitle', 'itemSubtitleField')}
                elementId={props.instanceId}
                key={key}
              >
                <div className="text" style={itemSubtitleStyles}>
                  {subtitleValue}
                </div>
              </SelectableItem>
            </div>
          </div>
        </SelectableItem>
      </SwiperSlide>
    )
  }

  useEffectWithPolling(props.uxpContext, "itemsData", refreshInterval || 300, async () => {
    if (isInDesignerMode()) {
      setWidgetData({
        'defaultSource': defaultItemsData
      });
      return;
    }

    if (!uiProps?.source) {
      setWidgetData({
        'defaultSource': []
      });
      return;
    }

    executeAndBind(props.uxpContext, uiProps?.source, uiProps.datasources, {})
      .then(res => {
        if (res) {
          setWidgetData({
            [uiProps.source?.source]: res
          })
        } else {
          setWidgetData({
            [uiProps.source?.source]: []
          })
        }
      })
  }, [props.designer]);

  console.log("WidgetData", widgetData)

  return (
    <DataSourceContext.Provider value={{ widgetData, setWidgetData }}>
      <WidgetWrapper className="uxp-card-list-widget">
        <div className="title-area">
          <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'container')}
            elementId={props.instanceId}
          >
            <div className="titles" style={{ backgroundColor: "transparent" }}>
              <div className="title">
                <SelectableItem
                  designer={props.designer}
                  props={selectUIProps(uiProps, XPRProps, 'title')}
                  elementId={props.instanceId}
                >
                  <div className="text" style={titleStyles}>{title}</div>
                </SelectableItem>
              </div>
              <div className="sub-title">

                <SelectableItem
                  designer={props.designer}
                  props={selectUIProps(uiProps, XPRProps, 'subtitle')}
                  elementId={props.instanceId}
                >
                  <div className="text" style={subtitleStyles}>{subtitle}</div>
                </SelectableItem>
              </div>
              <div className="action-label">

                <SelectableItem
                  designer={props.designer}
                  props={selectUIProps(uiProps, XPRProps, 'actionLabel')}
                  elementId={props.instanceId}
                >
                  <div className="text" style={actionLabelStyles}>{actionLabel}</div>
                </SelectableItem>
              </div>
            </div>
          </SelectableItem>
        </div>

        <div className="cards-container">
          <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'cardListConfig', 'source', 'refreshInterval')}
            elementId={props.instanceId}
          >
            <Swiper
              modules={[Pagination, Navigation]}
              navigation={false}
              pagination={{ clickable: true }}
              effect="slider"
              spaceBetween={0.1}
              className="swiper_container"
              slidesPerView={slidesPerView}
              centeredSlides={centeredSlides}
              style={{ height: viewHeight + "px" }}
            >
              {
                (
                  isInDesignerMode() ? widgetData['defaultSource'] : widgetData[uiProps.source?.source || 'defaultSource']
                )
                  ?.map((itemD: any, i: number) => {
                    return renderCard(itemD, i);
                  })
              }
            </Swiper>
          </SelectableItem>
        </div>
      </WidgetWrapper>
    </DataSourceContext.Provider>
  )
}

// registerCardTemplate({
//   id: 'card-list',
//   template: CardListWidget,
//   name: 'Card List',
//   description: 'Scrollable Card List',
//   complexity: 'easy',
//   layout: {
//     w: 9,
//     h: 12
//   },
// });

// registerMobileCardTemplate({
//   id: 'card-list',
//   template: CardListWidget,
//   name: 'Card List',
//   description: 'Horizontal list of cards'
// })